import React from 'react';
import '../css/Footer.css';

function Footer() {
	return (
		<body className='footerStyle'>
			<p className='footer'>
				Made by <a href='https://allyrilling.com'>Ally Rilling</a>.
			</p>
		</body>
	);
}

export default Footer;
